import { render, staticRenderFns } from "./barcodeReutilizable.vue?vue&type=template&id=07a0b8ea"
import script from "./barcodeReutilizable.vue?vue&type=script&lang=js"
export * from "./barcodeReutilizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports